import { ALGOLIA_PRODUCT_SORT_BY } from '@monofront/business/constants';
import {
  generateProductIndexName,
  getChannelFromLocale,
} from '@monofront/business/utils';
import { envType } from '@monofront/types';
import { useTranslations } from 'next-intl';
import SelectSort from './SelectSortBy';

interface ISortByProps {
  environment: envType;
  isSearch: boolean;
  setIsCustomSort?: (arg: boolean) => void;
  locale: string;
}

const SortBy: React.FC<ISortByProps> = ({
  environment,
  isSearch,
  setIsCustomSort,
  locale,
}) => {
  const tCatalog = useTranslations('Catalog');

  const generateSortByValue = (sortBy: string) =>
    generateProductIndexName(
      environment,
      false,
      getChannelFromLocale(locale),
      isSearch,
      sortBy,
    );

  return (
    <SelectSort
      defaultRefinement={generateSortByValue(
        ALGOLIA_PRODUCT_SORT_BY.POPULARITY,
      )}
      setIsCustomSort={setIsCustomSort}
      items={[
        setIsCustomSort
          ? {
              value: `hasCustomSort`,
              label: tCatalog('frequentlyBought'),
            }
          : {
              value: generateSortByValue(ALGOLIA_PRODUCT_SORT_BY.POPULARITY),
              label: tCatalog('popularity'),
            },
        {
          value: generateSortByValue(
            ALGOLIA_PRODUCT_SORT_BY.PRICE_PER_UNIT_ASC,
          ),
          label: `${tCatalog('priceByUnit')} ${tCatalog('asc')}`,
        },
        {
          value: generateSortByValue(
            ALGOLIA_PRODUCT_SORT_BY.PRICE_PER_UNIT_DESC,
          ),
          label: `${tCatalog('priceByUnit')} ${tCatalog('desc')}`,
        },
        {
          value: generateSortByValue(ALGOLIA_PRODUCT_SORT_BY.PRICE_ASC),
          label: `${tCatalog('price')} ${tCatalog('asc')}`,
        },
        {
          value: generateSortByValue(ALGOLIA_PRODUCT_SORT_BY.PRICE_DESC),
          label: `${tCatalog('price')} ${tCatalog('desc')}`,
        },
        {
          value: generateSortByValue(ALGOLIA_PRODUCT_SORT_BY.DATE),
          label: tCatalog('recentlyAdded'),
        },
        {
          value: generateSortByValue(ALGOLIA_PRODUCT_SORT_BY.BEST_RATE),
          label: tCatalog('bestRate'),
        },
      ]}
    />
  );
};

export default SortBy;
